// LIST_OF_API
const JOIN_BAT = "/user/create";
const CREATE_USER = "/user/create-account";
const LOGIN = "/auth/login";
const CREATE_PROFILE = "/profile/create";
const EDIT_PROFILE = "/profile/:id";
const UPDATE_PROFILE_VISIBILITY = "/profile/update-visibility/:id";
const GET_PROFILE_VISIBILITY = "/profile/view/:id";
const LIST_MY_PROFILES = "/profile/list/:id";
const VIEW_MY_PROFILE = "/profile/view/:id";
const DELETE_PROFILE = "/admin/profile/:id";

const LIST_ALL_ACCOUNT_VOLUNTEER = "/volunteer/list-accounts";
const LIST_ALL_ACCOUNT_ADMIN = "/admin/list-accounts";
const VIEW_ACCOUNT_ADMIN = "/admin/view-account/:id"
const UPDATE_VERIFICATION_ACCOUNT = "/volunteer/update-status/{accountId}";
const VIEW_VOLUNTEER_PROFILE = "/admin/volunteer/:id";
const UPDATE_VOLUNTEER_PROFILE = "/admin/update-volunteer-status/:id";
const LIST_ALL_PROFILES = "/volunteer/list-profiles";
const LIST_BAT_ACCOUNTS_FILTER = "/admin/filter-bat-account"
const LIST_PROFILES_TO_BE_VERIFIED = "/volunteer/filter";
const LIST_ACCOUNTS_TO_BE_VERIFIED = "/admin/filter";
const FORGET_PASSWORD = "/auth/forgot-password";
const RESET_PASSWORD = "/auth/reset-password";
const CHANGE_PASSSWORD = "/profile/update-password"
const UPDATE_ACCOUNT = "/profile/update-account/:id"
//email - admin@bat.com, password - password

const VOLUNTEER_LOGIN = "/api/auth/volunteer-login";
const UPDATE_PROFILE = "/volunteer/update-status/:id";
const UPDATE_ACCOUNT_VOLUNTEER = "/volunteer/update-status/:id";
const VIEW_VOLUNTEER = "/volunteer/view/{volunteerId}";

const VOLUNTEER_CREATION = "/admin/create-volunteer";
const EDIT_VOLUNTEER = "/admin/update-volunteer/:id";
const LIST_ALL_VOLUNTEERS = "/admin/list-volunteers";
//{ first_name, last_name, email, password, phone_number }
const LIST_SHORTLISTED_PROFILES = "/profile/shortlisted-profiles/:id";
const SHORTLIST_PROFILES = "/profile/shortlist";

//payment
const PAYMENT_TOKEN = "/payment/{tokenId}";
const PAYMENT_VIA_LINK = "/payment/stripe-link";
const PAYMENT_VIA_PROFILE = "/payment/stripe-subscription";

const SEARCH_PROFILE = "/profile/search";
const SUBSCRIPTION_LIST = "/admin/list-subscriptions";
const MATRIMONY_SUBSCRIPTION_LIST = "/admin/list-bat-subscriptions";

const LIST_BAT_ACCOUNTS = "/admin/list-bat-accounts";
const VIEW_BAT_ACCOUNT = "/admin//view-bat-account/:id";
const UPDATE_BAT_ACCOUNT_STATUS = "/admin/update-bat-account-status/:id";
const CONTACT_US = "/user/contact-us";
export {
  JOIN_BAT,
  CREATE_USER,
  LOGIN,
  CREATE_PROFILE,
  EDIT_PROFILE,
  LIST_MY_PROFILES,
  VIEW_MY_PROFILE,
  UPDATE_PROFILE_VISIBILITY,
  GET_PROFILE_VISIBILITY,
  VOLUNTEER_CREATION,
  EDIT_VOLUNTEER,
  LIST_ALL_VOLUNTEERS,
  VOLUNTEER_LOGIN,
  FORGET_PASSWORD,
  RESET_PASSWORD,
  LIST_ALL_PROFILES,
  UPDATE_PROFILE,
  LIST_PROFILES_TO_BE_VERIFIED,
  LIST_SHORTLISTED_PROFILES,
  SEARCH_PROFILE,
  SHORTLIST_PROFILES,
  PAYMENT_TOKEN,
  PAYMENT_VIA_LINK,
  PAYMENT_VIA_PROFILE,
  VIEW_VOLUNTEER_PROFILE,
  UPDATE_VOLUNTEER_PROFILE,
  UPDATE_VERIFICATION_ACCOUNT,
  LIST_ALL_ACCOUNT_VOLUNTEER,
  LIST_ALL_ACCOUNT_ADMIN,
  VIEW_ACCOUNT_ADMIN,
  UPDATE_ACCOUNT_VOLUNTEER,
  SUBSCRIPTION_LIST,
  LIST_BAT_ACCOUNTS,
  VIEW_BAT_ACCOUNT,
  UPDATE_BAT_ACCOUNT_STATUS,
  CONTACT_US,
  MATRIMONY_SUBSCRIPTION_LIST,
  CHANGE_PASSSWORD,
  UPDATE_ACCOUNT,
  DELETE_PROFILE,
  LIST_ACCOUNTS_TO_BE_VERIFIED,
  LIST_BAT_ACCOUNTS_FILTER
}; 